import React from 'react';
import { StyleSheet, Text } from './base_components';
import TitleActionLine from './title_action_line';

import FileInput from './file_input';
import StandardBoxList from './standard_box_list';
import TextButton from './buttons/text_button';

import { isValidFile } from '../lib/file_filter';
import { byteFormat } from '../tools/util';

const styles = StyleSheet.create({
  noFiles: {
    margin: '2rem',
    color: '#555',
    fontSize: '1.5rem',
    fontWeight: '600',
  },
  button: { marginRight: '1rem' },
  fileInput: { display: 'none' },
});

export default function VolumeUploadScreen(props) {
  const { path, uploadList, onChange } = props;
  const [selected_list, setSelectedList] = React.useState<any[]>([]);
  const fileRef = React.useRef<any>(null);
  const dirRef = React.useRef<any>(null);

  function _onRemovePress() {
    const new_list = uploadList
      .map((item, index) => {
        return selected_list.indexOf(index) === -1 ? item : null;
      })
      .filter((item) => item);
    onChange(new_list);
    setSelectedList([]);
  }
  function _onFilePress() {
    fileRef?.current?.click?.();
  }
  function _onDirPress() {
    dirRef?.current?.click?.();
  }
  function _onSelectedChange(new_list) {
    setSelectedList(new_list);
  }
  function _onFileChange(e) {
    _addFiles(fileRef?.current?.getFiles());
  }
  function _onDirChange(e) {
    _addFiles(dirRef?.current?.getFiles());
  }
  function _addFiles(files) {
    if (files) {
      const new_list = uploadList.slice();
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const dir =
          file.webkitRelativePath?.slice?.(0, -file.name.length) || '';
        const media_path = _join(path, dir, file.name);
        const key = media_path.toLowerCase();

        if (
          file.size > 0 &&
          isValidFile(media_path) &&
          !new_list.find((old) => old.key === key)
        ) {
          new_list.push({
            key,
            media_path,
            name: file.name,
            dir,
            file_size: file.size,
            file,
          });
        }
      }
      new_list.sort(_uploadSort);
      onChange(new_list);
    }
  }

  let content: any = null;
  let rows: any = [];
  if (uploadList.length > 0) {
    rows = uploadList.map((upload) => {
      return {
        list: [upload.name, upload.dir || '-', byteFormat(upload.file_size)],
      };
    });
  } else {
    content = <Text style={styles.noFiles}>No files selected.</Text>;
  }
  const buttons = (
    <>
      <TextButton
        style={styles.button}
        text='Remove'
        disabled={uploadList.length === 0}
        onPress={_onRemovePress}
      />
      <TextButton
        style={styles.button}
        text='Add File'
        onPress={_onFilePress}
      />
      <TextButton text='Add Folder' onPress={_onDirPress} />
    </>
  );
  return (
    <>
      <TitleActionLine title='Upload'>
        <TextButton
          text='Start Upload'
          disabled={uploadList.length === 0}
          onPress={props.onUpload}
        />
      </TitleActionLine>
      <StandardBoxList
        title='Files'
        detail={uploadList?.length}
        buttons={buttons}
        headers={['Name', 'Folder', 'Size']}
        selected={selected_list}
        onChange={_onSelectedChange}
        rows={rows}
      >
        {content}
      </StandardBoxList>
      <FileInput
        ref={fileRef}
        style={styles.fileInput}
        multiple={true}
        onChange={_onFileChange}
      />
      <FileInput
        ref={dirRef}
        style={styles.fileInput}
        webkitdirectory='true'
        onChange={_onDirChange}
      />
    </>
  );
}
function _join(...args) {
  return (
    '/' +
    args
      .reduce((memo, item) => [...memo, ...item.split('/')], [])
      .filter((d) => d)
      .join('/')
  );
}
const LOCALE_OPTS = { sensitivity: 'accent' };
function _uploadSort(a, b) {
  let ret = a.dir.localeCompare(b.dir, undefined, LOCALE_OPTS);
  if (ret === 0) {
    ret = a.key.localeCompare(b.key, undefined, LOCALE_OPTS);
  }
  return ret;
}
